import { getOrgLocale } from '../../../lib/locale';

export const PACK_WORDS = ['case', 'carton', 'slab', 'box', 'pack', 'crate', 'tray', 'pallet'];
export const unitWordOf = (it) => {
  const u = (it.unit || '').trim().toLowerCase();
  const bar = getOrgLocale().inventory_type === 'bar';
  return !u || PACK_WORDS.includes(u) ? (bar ? 'bottle' : 'unit') : u;
};
export const packWordOf = (it) => (it.pack_name || '').trim().toLowerCase() || (getOrgLocale().inventory_type === 'bar' ? 'case / slab' : 'pack');

const n = (v) => (v === '' || v === null || v === undefined || Number.isNaN(Number(v)) ? null : Number(v));

export const unitCost = (it) => {
  const pc = n(it.pack_cost); const up = n(it.units_per_pack);
  const base = pc != null && up ? pc / up : n(it.cost_price);
  const y = n(it.yield_pct);
  return base != null && y && y > 0 && y < 100 ? base / (y / 100) : base;
};

export function itemPricing(it, items = []) {
  const rate = n(it.tax_rate) ?? getOrgLocale().tax_rate;
  const exTax = (v) => (v != null && (it.cost_inc_tax ?? getOrgLocale().po_prices_include_tax) ? v / (1 + (rate || 0) / 100) : v);
  const cost = exTax(unitCost(it));
  const portion = it.sell_by === 'portion';
  const size = n(it.unit_size_ml); const pour = n(it.portion_ml);
  const servesPerUnit = portion && size && pour ? size / pour : 1;
  const mixer = it.mixer_item_id ? items.find((x) => x.id === it.mixer_item_id) : null;
  const mixerUnit = mixer ? itemPricing(mixer).unitCost : n(it.mixer_cost);
  const mixerCost = (mixerUnit || 0) * (n(it.mixer_qty) ?? 1);
  const productCost = cost == null ? null : cost / servesPerUnit;
  const serveCost = productCost == null ? null : productCost + (portion || it.mixer_item_id || n(it.mixer_cost) ? mixerCost : 0);
  const sell = n(it.sell_price);
  const sellEx = sell == null ? null : (it.sell_inc_tax !== false ? sell / (1 + (rate || 0) / 100) : sell);
  const margin = sellEx != null && serveCost != null ? sellEx - serveCost : null;
  const up = n(it.units_per_pack);
  const packCost = exTax(n(it.pack_cost)) ?? (cost != null && up ? cost * up : null);
  const packSell = n(it.sell_price_pack);
  const packSellEx = packSell == null ? null : (it.sell_inc_tax !== false ? packSell / (1 + (rate || 0) / 100) : packSell);
  const packMargin = packSellEx != null && packCost != null ? packSellEx - packCost : null;
  return {
    unitCost: cost, servesPerUnit, productCost, mixerCost, mixerName: mixer?.name, serveCost, sell, sellEx, rate,
    margin, marginPct: margin != null && sellEx ? (margin / sellEx) * 100 : null,
    profitPerUnit: margin != null ? margin * servesPerUnit : null,
    serveLabel: portion ? (it.portion_name || 'serve') : unitWordOf(it),
    packLabel: packWordOf(it), packCost, packSell, packSellEx, packMargin,
    packMarginPct: packMargin != null && packSellEx ? (packMargin / packSellEx) * 100 : null,
    minMargin: n(it.min_margin_pct),
    belowMin: n(it.min_margin_pct) != null && [margin != null && sellEx ? (margin / sellEx) * 100 : null, packMargin != null && packSellEx ? (packMargin / packSellEx) * 100 : null].some((v) => v != null && v < n(it.min_margin_pct)),
  };
}
